import * as React from "react";
import styled from 'styled-components'

import GlobalStyles from "./styles/GlobalStyles"
import HomeView from "./views/HomeView"
import FooterView from "./views/FooterView"

const Shell = styled.div`
  display: grid;
  grid-template-rows: var(--body-height) var(--footer-height);
  justify-content: center;
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-image: linear-gradient(to top right, var(--gradient-start), var(--gradient-end));
`

const App = () => 
  <>
  <GlobalStyles/>
  <Shell>
    <HomeView />
    <FooterView />
  </Shell>
  </>

export default App